import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    userData: null,
    errorMsg: '',
    signUpLoading: false,
    signInLoading: false,
    isLogin: false,

    otp: '',
  },
  reducers: {
    fetchUser: (state) => {
      let data = localStorage.getItem('userData')
      let parsedData = JSON.parse(data)
      state.userData = parsedData
    },
    logout: (state) => {
      state.userData = null
      localStorage.removeItem('userData')
    },
    userSignUp: (state) => {
      state.signUpLoading = true
      state.errorMsg = ''
      state.isLogin = false
    },
    userSignUpSuccess: (state, { payload: { payload } }) => {
      localStorage.setItem('userData', JSON.stringify(payload.data))
      state.signUpLoading = false
      state.userData = payload.data
      state.isLogin = true
    },
    userSignUpFailed: (state, { payload }) => {
      state.userData = null
      state.signUpLoading = false
      state.errorMsg = payload.message
      state.isLogin = false
    },

    userSignIn: (state) => {
      state.signInLoading = true
      state.errorMsg = ''
      state.isLogin = false
    },
    userSignInSuccess: (state, { payload: { payload } }) => {
      localStorage.setItem('userData', JSON.stringify(payload.data))
      state.signInLoading = false
      state.userData = payload.data
      state.isLogin = true
    },
    userSignInFailed: (state, { payload }) => {
      state.userData = null
      state.signInLoading = false
      state.errorMsg = payload.message
      state.isLogin = false
    },

    userVerification: (state) => {
      state.otp = ''
    },
    userVerificationSuccess: (state, { payload: { payload } }) => {
      state.otp = payload.data.otp
    },
    userVerificationFailed: (state, { payload }) => {
      state.otp = ''
    },
  },
})

export const {
  fetchUser,
  logout,
  userSignUp,
  userSignUpFailed,
  userSignUpSuccess,
  userVerification,
  userVerificationFailed,
  userVerificationSuccess,
  userSignIn,
  userSignInSuccess,
  userSignInFailed,
} = slice.actions

export default slice.reducer
